<div class="ui-lg-5 ui-md-12 ui-g-12">
	<p-card styleClass="ui-card-shadow">
		<ng-template #header>
			<h3 class="ui-title-bar">
				<span>SmartyGPT</span>
				<button
					pButton
					type="button"
					class="p-button-text"
					icon="fas fa-trash"
					[label]="'pages.smarty-gpt.clear-conversation' | translate"
					[disabled]="states.isTyping"
					(click)="clearConversationHistory()"></button>
			</h3>
		</ng-template>
		<div class="chat-container">
			<div class="chat-messages" #messageContainer>
				@for (message of messages; track message; let index = $index) {
					<div
						class="chat-message"
						[ngStyle]="{
							cursor: isObjectNotNull(message?.responseIndex) ? 'pointer' : 'auto',
						}"
						[ngClass]="{
							'user-message': message.user === user.name,
							'asistant-message': message.user !== user.name,
							'selectable-message': isObjectNotNull(message?.responseIndex),
						}"
						(click)="selectMessage(message, index)">
						@if (message.responseIndex === selectedMessage?.responseIndex) {
							<span class="mr-2">
								<i class="fa-solid fa-eye"></i>
							</span>
						}
						<strong>{{ message.user }}:</strong>
						{{ message.text }}
					</div>
				}
				@if (states.isTyping) {
					<div class="chat-message asistant-message">
						<strong>Smarty-GPT:</strong>
						<span class="typing">
							<span class="dot">.</span>
							<span class="dot">.</span>
							<span class="dot">.</span>
						</span>
					</div>
				}
			</div>
			<div class="chat-input">
				<textarea
					type="text"
					rows="2"
					cols="1"
					pInputText
					[placeholder]="'pages.smarty-gpt.enter-message' | translate"
					[(ngModel)]="newMessage"
					[disabled]="states.isTyping"
					(keyup.enter)="sendMessage()"></textarea>
				<button
					pButton
					type="button"
					icon="pi pi-send"
					[label]="'form.btn.send' | translate"
					[disabled]="states.isTyping"
					(click)="sendMessage()"></button>
			</div>
		</div>
	</p-card>
</div>
<div class="ui-lg-7 ui-md-12 ui-g-12">
	<p-card styleClass="ui-card-shadow">
		<ng-template #header>
			<h3 class="ui-title-bar">
				<span>{{ 'report' | translate }}</span>
				<span>
					<button
						class="mr-2"
						pButton
						icon="fas fa-file-excel"
						[disabled]="!states.isReadyReport"
						(click)="excelExport()"></button>
					<button pButton type="button" icon="fas fa-save" [disabled]="!states.isReadyReport" (click)="save()"></button>
				</span>
			</h3>
		</ng-template>
		<div class="render-container">
			@if (states.isFirstCreation) {
				<div class="report-animation">
					<div class="icons">
						<i [class]="chartAnimationIcon"></i>
					</div>
				</div>
			}
			@if (!states.isFirstCreation && !states.isReadyReport) {
				<div class="report-animation" @fade>
					<loader></loader>
				</div>
			}
			@if (states.isReadyReport) {
				<div class="table box-zero">
					@if (smartyGptReport?.data?.length === 0) {
						<div class="ui-lg-12 ui-md-12 ui-g-12 box-zero record-not-found-container">
							<records-not-found></records-not-found>
						</div>
					}
					@if (smartyGptReport?.data?.length > 0) {
						<div class="ui-lg-12 ui-md-12 ui-g-12 box-zero">
							<div class="text-center mb-2 bold">{{ smartyGptReport.description }}</div>
							@if (smartyGptReport.data.length > 0) {
								<p-table
									#pTable
									[value]="smartyGptReport.data"
									[columns]="smartyGptReport.columns"
									[paginator]="true"
									[rows]="10"
									[rowsPerPageOptions]="rowsPerPage"
									[reorderableColumns]="true"
									[resizableColumns]="true"
									[scrollable]="true">
									<ng-template #header let-columns>
										<tr>
											@for (col of columns; track col) {
												<th pReorderableColumn pResizableColumn>
													{{ col.header }}
												</th>
											}
										</tr>
									</ng-template>
									<ng-template #body let-rowData let-columns="columns">
										<tr>
											@for (col of columns; track col) {
												<td>
													<sis-col-value [col]="col" [rowData]="rowData"></sis-col-value>
												</td>
											}
										</tr>
									</ng-template>
								</p-table>
							}
						</div>
					}
				</div>
			}
		</div>
	</p-card>
</div>
